export enum OmEmeaRequestStatus {
    SAVED = 'saved',
    SUBMITTED = 'submitted',
    PENDING_CUSTOMER_ACTION = 'pending-customer-action',
    REFERRED_OUT = 'referred-out',
    UNDER_REVIEW = 'under-review',
    CLOSED = 'closed'
}
